/*

Zone List

*/

import React, { useEffect, useState } from "react";
import InputTextSimple from "../../../components/common/InputText/InputTextSimple";
import PlusIcon from ".//..//..//..//assets//images//icons//plus-white.svg";
// import DropDown from "./DropDown";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import Items from ".//..//..//..//assets//images//icons//items.svg";
import Pen from ".//..//..//..//assets//images//icons//pen.svg";
import ButtonWithIcon from "../../../components/common/buttons/ButtonWithIcon";
import BinIcon from "../../../assets/images/icons/bin.svg";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import useAuth from "../../../hooks/useAuth";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const Zonak = () => {
  const [calCount, setCalCount] = useState(125);
  const navigate = useNavigate();

  const handleRowClicked = (row) => {
    const zoneId = row["sorszama"];

    navigate(`${ROUTES.ADMIN_ZONE_ITEMS}?zone-id=${zoneId}`);
    console.log(`Selected Row Data:\n${JSON.stringify(row)}`);
  };

  const handleDeleteClick = (row) => {
    const zoneId = row?.id;
    const token = getAuth()?.bearerToken;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#8CD4F5",
        cancelButtonColor: "#eee",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          HttpHelper.DeleteRequest({
            route: API_ROUTES.ZONE_DELETE,
            id: zoneId,
            token: token,
          })
            .then((result) => {
              console.log(result);
              if (result.status == 200) {
                fetchZones();
                toast.success("Zone successfully removed !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 404) {
                toast.error("API not found !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 403) {
                toast.error("Sorry, the zone cannot be deleted as there are items assigned to it  !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 500) {
                toast.error("Server error !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else {
                toast.error("Unknown server error !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              toast.error("Unknown server error !", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            text: "Zone is safe :)",
            icon: "error",
          });
        }
      });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "50px",
        background: "#eee",
        marginTop: "0.625rem",
        marginBottom: "0.625rem",
        borderRadius: "1rem",
        border: 0,
        cursor: "pointer",
        boxShadow: "0px 4px 4px 0px rgba(16, 16, 16, 0.10)",
      },
    },

    headCells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
    cells: {
      style: {
        paddingLeft: "1rem",
        paddingRight: "1rem",
      },
    },
  };

  const columns = [
    {
      name: "Sorszáma",
      selector: (row) => row.sorszama,
      width: "10rem",
    },
    {
      name: "Név",
      selector: (row) => row.ugyfel_neve,
    },
    {
      name: "",
      selector: (row) => row.szerkeszteni,
      width: "5rem",
    },
    {
      name: "",
      selector: (row) => row.allapot,
      width: "4rem",
    },
  ];

  // states
  const { getAuth, clearAuth } = useAuth();
  const [zones, setZones] = useState([]);
  const [searchText, setSearchText] = useState("");

  const fetchZones = () => {
    HttpHelper.GetRequest({
      route: API_ROUTES.ZONE_LIST,
      token: getAuth()?.bearerToken,
      searchQuery: searchText,
    })
      .then((data) => {
        if (data.status == 200) {
          const zoneList = data?.data?.zones;

          const newData = zoneList.map((item) => ({
            sorszama: item.id,
            ugyfel_neve: item.nev,

            szerkeszteni: (
              <Link to={`${ROUTES.ADMIN_ZONE_EDIT}?id=${item.id}`}>
                <img src={Pen} className="p-[6px] border-2 border-gray-400 border-solid rounded-full" />
              </Link>
            ),

            allapot: (
              <img
                src={BinIcon}
                alt="Bin Icon"
                className="p-[6px]  border-2 border-gray-400 border-solid rounded-full"
                onClick={() => {
                  handleDeleteClick(item);
                }}
              />
            ),
          }));

          setZones(newData);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          console.log(data);
          toast.error("Unknown server error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unknown server error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    fetchZones();
  }, [searchText]);
  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <div className=" mt-[3rem]  flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
          <Link to={ROUTES.ADMIN_HOME}>
            <i className="bg-[rgba(6,85,103,0.5)] h-[4.3rem] w-[4.3rem] rounded-full flex justify-center items-center">
              <img src={Items} alt="items icon" className="w-[2.5rem] " />
            </i>
          </Link>
          <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Zónák</h2>
        </div>
        {/* Header Start */}
        <div className="mt-[3rem] flex flex-col lg:flex-row  justify-between gap-4 ">
          <div className="w-full md:w-1/4">
            <InputTextSimple
              placeholder={`Zóna keresése`}
              variant="bold"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
          </div>
          <div className="flex items-center gap-[1.125rem] ">
            {/* <DropDown /> */}
            <Link to={ROUTES.ADMIN_ZONE_ADD}>
              <ButtonWithIcon label={`Új zóna hozzáadása`} icon={PlusIcon} />
            </Link>
          </div>
        </div>
        {/* Header End */}

        {/* Table Start */}
        <div className="mt-[3rem] w-full  ">
          <DataTable columns={columns} data={zones} onRowClicked={handleRowClicked} customStyles={customStyles} />
        </div>
        {/* Table End */}
      </div>
    </>
  );
};

export default Zonak;
